import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { DeliveryZone } from "../../common.types";
import { ApiRoutesCommon } from "../../constants";

export const requestGetDeliveryZones = async (): Promise<DeliveryZone[]> => {
  return await instance.get(buildUrl(ApiRoutesCommon.AllDeliveryZones));
};
